/**
 * Inställningar för att hämta backend data för filter
 */
export class ParametersConfig {

    /* Base-URL till server, ex. "https://..." */
    public apiBaseUrl: string;

    /* URL till server */
    public serverUrl: string = '/api/params';

    /* Data by id, ex. "aldersgrupp" */
    public data: string;

    /* Dataformat, ex. "json" */
    public format: string;

    /* Get tree of data */
    public gettree: boolean;

}
